<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '~/types/types'

/** Embeds the existing public booking staff section as a block. */
defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <div>
    <h3
      v-if="data.title"
      class="site-display mb-6 text-center text-2xl tracking-tight sm:text-3xl"
    >
      {{ data.title }}
    </h3>
    <LandingBookableStaffSection />
  </div>
</template>
